import { Button, Checkbox, Col, Drawer, Empty, List, Row, Select } from 'antd';
import getFormatMessage from '../../../../locales/get-format-message';
import closeIcon from '../../../../assets/svg/close-icon.svg';
import { IGameEnvModel } from '../../../../model/api-modules/env';
import { useEffect, useState } from 'react';
import { serviceOpenList } from '../../../../api/services';
import {
  IAPIGameItem,
  IAPIServiceConfigItem,
} from '../../../../model/api-modules';
import { IEnvUnionItem } from '../../../../model';
import { isVersionGreaterThan } from '../../lib';
import loadingIcon from '../../../../assets/svg/loading-icon.svg';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { uniq } from 'lodash';
import { AutoTooltip } from '../../../../components/auto-tooltip';
import questionIcon from '../../../../assets/svg/question-icon.svg';
import { CustomPopover } from '../../../../components/custom-popover';
import emptyIcon from '../../../../assets/images/message-empty.png';
import warnBlue from '../../../../assets/svg/warn-blue.svg';
import successIcon from '../../../../assets/svg/success-circle-fill.svg';
import { envExport } from '../../../../api/game/env';
import { useHistory } from 'react-router-dom';

interface IProps {
  readonly visible: boolean;
  readonly onClose: () => void;
  readonly envList: ReadonlyArray<IGameEnvModel>;
  readonly selectedGame?: IAPIGameItem;
  readonly allServiceConfig: ReadonlyArray<IAPIServiceConfigItem> | null;
}

enum SubServiceID {
  BattlePass = 'battlepass',
  Season = 'season',
  Matchmaking = 'Matchmaking',
  SkillRating = 'skillrating',
  FactionSet = 'factionset',
  Gamemode = 'gamemode',
}

export const EnvExport = (props: IProps) => {
  const history = useHistory();
  const [envOptions, setEnvOptions] = useState<
    ReadonlyArray<{ label: JSX.Element; value: Number }>
  >([]);
  const [selectEnv, setSelectEnv] = useState<Number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [unionEnvironmentList, setUnionEnvironmentList] = useState<
    ReadonlyArray<IEnvUnionItem>
  >([]);
  const [serviceList, setServiceList] = useState<string[]>([]);
  const [clientApiChecked, setClientApiChecked] = useState<boolean>(true);
  const [selectService, setSelectService] = useState<string[]>([]);
  const [exportTask, setExportTask] = useState<Record<string, any>>({});

  const optionalServiceList = [
    'Player',
    'Battle',
    // 'Party',
    // 'Lobby',
    'Matchmaking',
    'BattlePass',
    'Season',
    'DS Hosting',
    'Auto-Task',
    // 'Goals',
    'Friends',
    'Guild',
    'Mails',
    'Notifications',
    'Statistics',
    'Token',
    'Segments',
    'Telemetry',
    'Text Chat',
    'Custom Data',
  ];

  // 数组内服务只展示子服务
  const optionalSubServiceList: { [key: string]: string[] } = {
    Battle: ['Party', 'Lobby', 'Custom Tags'],
    'Auto-Task': ['Goals', 'Season', 'BattlePass'],
    'DS Hosting': ['Gamemode', 'Fleet'],
  };

  useEffect(() => {
    setEnvOptions(
      props.envList.map((env) => {
        const gos = JSON.parse(env.GosParams || '{}');
        const version = gos?.GameServiceVersion || '';
        return {
          label: (
            <div className="export-env-select-item">
              <span className="export-item-name">{env.Name}</span>
              {version && (
                <span className="export-item-version">{version}</span>
              )}
            </div>
          ),
          value: env.id,
        };
      })
    );
  }, props.envList);

  useEffect(() => {
    if (unionEnvironmentList) {
      getTheSelectedUnionEnvironmentId();
    }
  }, [unionEnvironmentList]);

  const getTheSelectedUnionEnvironmentId = () => {
    const menuCheckedIDs: string[] = [];
    const commonSelectServices: string[] = [];
    unionEnvironmentList.forEach((item) => {
      item.checkedList.forEach((subItem) => {
        commonSelectServices.push(subItem);
      });
      if (item.checkedList.length > 0) {
        menuCheckedIDs.push(item.id);
      }
    });
    setSelectService(commonSelectServices);
  };

  const getFormattedSelectedValues = (
    values: any[],
    selectedMenu: IEnvUnionItem
  ) => {
    const isMultiPlayerMenu = selectedMenu.commonServices.some(
      (item) => item.id === 'battlepass'
    );
    if (!isMultiPlayerMenu) {
      return values;
    }
    const preValuesHasBattlePass = selectedMenu.checkedList.includes(
      SubServiceID.BattlePass
    );
    const valuesHasBattlePass = values.includes(SubServiceID.BattlePass);

    if (preValuesHasBattlePass || valuesHasBattlePass) {
      return valuesHasBattlePass
        ? uniq([...values, SubServiceID.Season])
        : values.filter((item) => item !== SubServiceID.Season);
    }
    return values;
  };

  const getFormattedSelectedGamemodeValues = (
    values: any[],
    selectedMenu: IEnvUnionItem
  ) => {
    const isMultiPlayerMenu = selectedMenu.commonServices.some(
      (item) =>
        item.id === SubServiceID.Matchmaking ||
        item.id === SubServiceID.SkillRating
    );
    if (!isMultiPlayerMenu) {
      return values;
    }
    const preValuesHasMatchmaking = selectedMenu.checkedList.includes(
      SubServiceID.Matchmaking
    );
    const valuesHasMatchmaking = values.includes(SubServiceID.Matchmaking);

    const preValuesSkillRating = selectedMenu.checkedList.includes(
      SubServiceID.SkillRating
    );
    const valuesHasSkillRating = values.includes(SubServiceID.SkillRating);

    const preValuesGamemode = selectedMenu.checkedList.includes(
      SubServiceID.Gamemode
    );
    const valuesHasGamemode = values.includes(SubServiceID.Gamemode);
    const envItem = props.envList.find((env) => env.id === selectEnv);
    const gos = JSON.parse(envItem?.GosParams || '{}');
    if (!isVersionGreaterThan(gos?.GameServiceVersion)) {
      if (preValuesHasMatchmaking || valuesHasMatchmaking) {
        return valuesHasMatchmaking
          ? uniq([...values, SubServiceID.Gamemode])
          : values.filter((item) => item !== SubServiceID.Gamemode);
      }
      return values;
    }
    if (
      preValuesHasMatchmaking ||
      valuesHasMatchmaking ||
      preValuesSkillRating ||
      valuesHasSkillRating ||
      preValuesGamemode ||
      valuesHasGamemode
    ) {
      return valuesHasMatchmaking || valuesHasSkillRating || valuesHasGamemode
        ? uniq([...values, SubServiceID.Gamemode, SubServiceID.FactionSet])
        : values.filter(
            (item) =>
              item !== SubServiceID.Gamemode && item !== SubServiceID.FactionSet
          );
    }
    return values;
  };

  // 服务同步 选中第二级
  const handleServiceGroup = (e: CheckboxChangeEvent, item: IEnvUnionItem) => {
    const isChecked = e.target.checked;
    setUnionEnvironmentList((prevList) =>
      prevList.map((listItem) =>
        listItem.id === item.id
          ? {
              ...listItem,
              checkedList: isChecked
                ? listItem.commonServices.map((subItem) => subItem.id)
                : [],
            }
          : listItem
      )
    );
  };

  // 服务同步 选中第三级
  const handleSyncServiceChange = (
    values: any[],
    selectedMenu: IEnvUnionItem
  ) => {
    const newValues = getFormattedSelectedValues(values, selectedMenu);
    const cuurnetValues = getFormattedSelectedGamemodeValues(
      newValues,
      selectedMenu
    );

    setUnionEnvironmentList((prevMenuList) =>
      prevMenuList.map((menuItem) => {
        if (menuItem.id === selectedMenu.id) {
          return {
            ...menuItem,
            // checkedList: i.commonServices
            //   .filter((subItem) => values.includes(subItem.id.toString()))
            //   .map((subItem) => subItem.id),
            checkedList: cuurnetValues,
          };
        }
        return menuItem;
      })
    );
  };

  const toLowerCaseAndRemoveSpaces = (str: string) => {
    return str.toLowerCase().replace(/\s+/g, '');
  };

  const handleClientApi = (e: CheckboxChangeEvent) => {
    const isChecked = e.target.checked;
    setClientApiChecked(isChecked);
  };

  const getServiceList = async () => {
    if (!props.selectedGame || !selectEnv || !props.allServiceConfig) return;
    setLoading(true);
    const res = await serviceOpenList(props.selectedGame.gameID, selectEnv);
    const serviceIds = res
      .filter((service) => service.ServiceID && service.Status !== 2)
      .map((service) => service.ServiceID)
      .filter((id) => {
        const serviceItem = props.allServiceConfig?.find((it) => it.id === id);
        if (!serviceItem) {
          return false;
        }
        return optionalServiceList.includes(serviceItem?.Name);
      });
    const services = props.allServiceConfig
      .filter((config) => serviceIds.includes(config.id))
      .map((config) => {
        if (config.Business === 'g6') {
          return config;
        }
        return null;
      })
      .filter((config) => config !== null) as IAPIServiceConfigItem[];
    const sortOrder = [
      'Multiplayer',
      'Social',
      'Economy',
      'Engagement',
      'Analytics',
      'Content',
    ];
    services.sort((a, b) => {
      const aIndex = sortOrder.indexOf(a.ParentName);
      const bIndex = sortOrder.indexOf(b.ParentName);

      // 处理不在排序列表中的情况（放在最后）
      const aSortIndex = aIndex === -1 ? sortOrder.length : aIndex;
      const bSortIndex = bIndex === -1 ? sortOrder.length : bIndex;

      return aSortIndex - bSortIndex;
    });
    const menuMap: { [y: string]: IAPIServiceConfigItem[] } = {};
    services.forEach((item) => {
      if (menuMap[item.ParentName]) {
        menuMap[item.ParentName].push(item);
      } else {
        menuMap[item.ParentName] = [item];
      }
    });
    const envItem = props.envList.find((env) => env.id === selectEnv);
    const gos = JSON.parse(envItem?.GosParams || '{}');
    const currentServices: string[] = [];
    const list: IEnvUnionItem[] = [];
    const menuCheckedIDs: string[] = [];
    Object.keys(menuMap).forEach((item) => {
      const checkedList: string[] = [];
      // menuMap[item].forEach((subItem) => {
      //   checkedList.push(subItem.id as number);
      // });
      menuCheckedIDs.push(item);
      const unionServices: { id: string; name: string }[] = [];
      menuMap[item].forEach((it) => {
        if (
          it.Name === 'Battle' ||
          it.Name === 'Auto-Task' ||
          (it.Name === 'DS Hosting' &&
            isVersionGreaterThan(gos?.GameServiceVersion))
        ) {
          const subList: string[] = it.SubServiceNames?.split(',') || [];
          if (subList.length !== 0) {
            const optionalSubServices: string[] = optionalSubServiceList[
              it.Name
            ].map((optionalSub) => {
              return toLowerCaseAndRemoveSpaces(optionalSub);
            });
            if (it.Name === 'DS Hosting') subList.push('fleet');
            [...subList]
              .sort((a, b) => {
                const aIndex = optionalSubServices.indexOf(a);
                const bIndex = optionalSubServices.indexOf(b);
                return aIndex > bIndex ? 1 : -1;
              })
              .forEach((subItem) => {
                if (optionalSubServices.includes(subItem)) {
                  const subName = optionalSubServiceList[it.Name].find(
                    (nameItem) =>
                      toLowerCaseAndRemoveSpaces(nameItem) === subItem
                  );
                  unionServices.push({
                    id: subItem,
                    name: subName || subItem,
                  });
                  checkedList.push(subItem);
                  currentServices.push(subItem);

                  if (subItem === 'goals') {
                    unionServices.push({
                      id: SubServiceID.Season,
                      name: 'Season',
                    });
                    checkedList.push(SubServiceID.Season);
                    currentServices.push(SubServiceID.Season);
                  }
                }
              });
          }
        } else {
          if (it.Name !== 'DS Hosting') {
            if (
              it.Name === 'Matchmaking' &&
              isVersionGreaterThan(gos?.GameServiceVersion)
            ) {
              unionServices.push({
                id: SubServiceID.Matchmaking,
                name: 'Matchmaker',
              });
              checkedList.push(SubServiceID.Matchmaking);
              currentServices.push(SubServiceID.Matchmaking);

              unionServices.push({
                id: SubServiceID.SkillRating,
                name: 'SkillRating',
              });
              checkedList.push(SubServiceID.SkillRating);
              currentServices.push(SubServiceID.SkillRating);

              unionServices.push({
                id: SubServiceID.FactionSet,
                name: 'FactionSet',
              });
              checkedList.push(SubServiceID.FactionSet);
              currentServices.push(SubServiceID.FactionSet);
            } else {
              unionServices.push({
                id: it.Name,
                name: it.Name,
              });
              checkedList.push(it.Name);
              currentServices.push(it.Name);
            }
          }
        }
      });

      const getTitle = () => {
        return item.toUpperCase()
          ? item.toUpperCase()[0] + item.slice(1)
          : item;
      };

      list.push({
        commonServices: unionServices,
        checkedList,
        title: getTitle(),
        id: item,
        checked: true,
        indeterminate: false,
      });
    });
    setUnionEnvironmentList(list);
    setServiceList(currentServices);
    setLoading(false);
  };

  useEffect(() => {
    getServiceList();
  }, [selectEnv]);

  const onClose = () => {
    props.onClose();
    setExportTask({});
    setSelectEnv(null);
    setSelectService([]);
    setClientApiChecked(true);
    setUnionEnvironmentList([]);
    setServiceList([]);
  };

  const viewTask = () => {
    const envItem = props.envList.find(
      (item) => item.Guid === exportTask?.env_id
    );
    history.push(
      `/studio/${props.selectedGame?.studioID}/audithub?gameId=${props.selectedGame?.gameID}&envId=${envItem?.Guid}&task=sync&subtask=535&taskId=${exportTask?.k8s_app_task_id}`
    );
  };

  const handleEnvChange = (value: Number) => {
    setSelectEnv(value);
  };

  const handleOkExport = async () => {
    const envItem = props.envList.find((it) => it.id === selectEnv);
    if (envItem && props.selectedGame) {
      const res = await envExport({
        services: clientApiChecked
          ? selectService.concat(['api-control'])
          : selectService,
        game_id: Number(props.selectedGame.gameID),
        env_id: envItem.Guid,
        gameID: props.selectedGame.gameID,
        envID: envItem.id.toString(),
      });
      if (res?.code === 0 && res?.result?.k8s_app_task_id) {
        setExportTask(res?.result);
      }
    }
  };

  const renderExportContent = () => {
    const emptyText = (
      <Empty
        image={emptyIcon}
        imageStyle={{ height: 60 }}
        description={
          <span style={{ fontSize: '12px' }}>
            {getFormatMessage('no_services_exported')}
          </span>
        }
      />
    );
    if (exportTask?.k8s_app_task_id) {
      const envItem = props.envList.find(
        (item) => item.Guid === exportTask?.env_id
      );
      return (
        <div className="export-success-box">
          <img src={successIcon} className="export-success-icon" />
          <div className="export-success-title">
            {getFormatMessage('export_task_created_successfully')}
          </div>
          <div className="export-success-tips">
            <div>{getFormatMessage('export_download_tips')}</div>
            <div>{getFormatMessage('export_close_tips')}</div>
          </div>
          <div className="export-success-btn">
            <Button
              className="gc-btn-default sync-cancel"
              style={{ width: 128 }}
              onClick={onClose}
            >
              {getFormatMessage('close')}
            </Button>
            <Button
              className="gc-btn gc-btn-primary"
              style={{ width: 128 }}
              onClick={viewTask}
            >
              {getFormatMessage('go_to_view')}
            </Button>
          </div>
          <div className="export-success-table">
            <div
              className="table-col"
              style={{ borderBottom: '1px solid #E5E6EB' }}
            >
              <div className="table-col-item">
                <div>{getFormatMessage('task_id')}</div>
                <div className="table-col-item-value">
                  {exportTask?.k8s_app_task_id || ''}
                </div>
              </div>
              <div className="table-col-item">
                <div>{getFormatMessage('org_env')}</div>
                <div className="table-col-item-value">
                  {envItem?.Name || ''}
                </div>
              </div>
            </div>
            <div className="table-col">
              <div className="table-col-item">
                <div>{getFormatMessage('approval_version')}</div>
                <div className="table-col-item-value">
                  {exportTask?.api_version || ''}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="export-drawer-box">
        <div className="export-tips">{getFormatMessage('env_export_tips')}</div>
        <div className="export-tips-info">
          <img src={warnBlue} />
          <div>{getFormatMessage('env_export_tips_desc')}</div>
        </div>
        <p
          className="select-env"
          style={{ fontSize: '16px', color: '#000', fontWeight: 600 }}
        >
          {getFormatMessage('select_env')}
        </p>
        <div className="org-label">{getFormatMessage('org_env')}</div>
        <Select
          className="export-select"
          style={{ height: 32 }}
          options={envOptions.slice()}
          virtual={false}
          onChange={handleEnvChange}
          value={selectEnv}
        />
        <p className="select-service">
          {getFormatMessage('select_export_service')}
        </p>
        {loading ? (
          // loadingContent()
          <div className="loading-box">
            <img src={loadingIcon} className="loading-icon" />
            <div className="loading-tips">
              {getFormatMessage('being_sync_not_close_page')}
            </div>
          </div>
        ) : (
          <>
            {serviceList && serviceList.length > 0 ? (
              <>
                <div className="services-select services-unselect">
                  <div className="services-select-item">
                    {unionEnvironmentList.map((item: IEnvUnionItem) => {
                      return (
                        <div
                          key={item.id}
                          className="services-select-item-check"
                        >
                          <Checkbox
                            className="sync-item-left"
                            onChange={(e) => handleServiceGroup(e, item)}
                            indeterminate={
                              item.checkedList?.length > 0 &&
                              item.checkedList.length <
                                item.commonServices.length
                            }
                            checked={
                              item.checkedList?.length > 0 &&
                              item.checkedList.length ===
                                item.commonServices.length
                            }
                            disabled
                          >
                            {item.title}
                          </Checkbox>
                          <div className="sync-item">
                            <Checkbox.Group
                              onChange={(e) => handleSyncServiceChange(e, item)}
                              value={item.checkedList.map((id) =>
                                id.toString()
                              )}
                              disabled
                            >
                              <Row className="sync-zilei">
                                {item.commonServices.map((subItem) => {
                                  let isDisabled = false;
                                  // const disableTip =
                                  //     isDisabled &&
                                  //     getFormatMessage(
                                  //       'season_sync_tip'
                                  //     );
                                  let disableTip = '';
                                  if (
                                    subItem.id === SubServiceID.Season &&
                                    item.checkedList.includes(
                                      SubServiceID.BattlePass
                                    )
                                  ) {
                                    isDisabled = true;
                                    disableTip =
                                      getFormatMessage('season_sync_tip');
                                  }
                                  if (
                                    subItem.id === SubServiceID.Gamemode &&
                                    (item.checkedList.includes(
                                      SubServiceID.SkillRating
                                    ) ||
                                      item.checkedList.includes(
                                        SubServiceID.Matchmaking
                                      ))
                                  ) {
                                    isDisabled = true;
                                    disableTip =
                                      getFormatMessage('gamemode_sync_tip');
                                  }
                                  if (
                                    subItem.id === SubServiceID.FactionSet &&
                                    (item.checkedList.includes(
                                      SubServiceID.SkillRating
                                    ) ||
                                      item.checkedList.includes(
                                        SubServiceID.Matchmaking
                                      ) ||
                                      item.checkedList.includes(
                                        SubServiceID.Gamemode
                                      ))
                                  ) {
                                    isDisabled = true;
                                    disableTip = getFormatMessage(
                                      'factionset_sync_tip'
                                    );
                                  }
                                  let toolTips = '';
                                  if (subItem.name === 'Custom Data') {
                                    toolTips =
                                      getFormatMessage('custom_data_tips');
                                  } else if (subItem.name === 'Fleet') {
                                    toolTips = getFormatMessage('ds_sync_tips');
                                  }
                                  console.log(isDisabled);

                                  const checkboxNode = (
                                    <Checkbox
                                      value={subItem.id.toString()}
                                      // disabled={isDisabled}
                                      disabled
                                    >
                                      {subItem.name}
                                      {toolTips && (
                                        <AutoTooltip
                                          title={toolTips}
                                          placement="top"
                                        >
                                          <img
                                            src={questionIcon}
                                            style={{
                                              display: 'inline-block',
                                              width: 12,
                                              height: 12,
                                              marginLeft: 4,
                                              marginTop: -2,
                                            }}
                                          />
                                        </AutoTooltip>
                                      )}
                                    </Checkbox>
                                  );
                                  return (
                                    <Col
                                      className="sync-zilei-col"
                                      key={subItem.id}
                                    >
                                      <CustomPopover content={disableTip}>
                                        {checkboxNode}
                                      </CustomPopover>
                                    </Col>
                                  );
                                })}
                              </Row>
                            </Checkbox.Group>
                          </div>
                        </div>
                      );
                    })}
                    <div className="services-select-item-check">
                      <Checkbox
                        className="sync-item-left"
                        onChange={(e) => handleClientApi(e)}
                        checked={clientApiChecked}
                        disabled
                      >
                        Client API Control
                      </Checkbox>
                      <div className="sync-item">
                        <Row className="sync-zilei">
                          <Col className="sync-zilei-col">
                            <Checkbox
                              checked={clientApiChecked}
                              onChange={(e) => handleClientApi(e)}
                              disabled
                            >
                              All Services
                              {/* <AutoTooltip
                                title={getFormatMessage('client_api_sync_tips')}
                                placement="top"
                              >
                                <img
                                  src={questionIcon}
                                  style={{
                                    display: 'inline-block',
                                    width: 12,
                                    height: 12,
                                    marginLeft: 4,
                                    marginTop: -2,
                                  }}
                                />
                              </AutoTooltip> */}
                            </Checkbox>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <List locale={{ emptyText }} bordered style={{ width: 450 }} />
                <p
                  style={{
                    fontSize: 12,
                    color: '#666666',
                    marginTop: 5,
                  }}
                >
                  {getFormatMessage('verify_services_activated_desc')}
                </p>
              </>
            )}
          </>
        )}
      </div>
    );
  };

  const footer = () => {
    if (!exportTask?.k8s_app_task_id) {
      return (
        <div>
          <Button
            className="gc-btn-default sync-cancel"
            style={{ width: '80px', borderRadius: '4px' }}
            onClick={onClose}
            // disabled={btnLoading}
          >
            {getFormatMessage('cancel')}
          </Button>
          <Button
            // loading={btnLoading}
            onClick={handleOkExport}
            className="gc-btn gc-btn-primary"
            style={{ minWidth: '80px', borderRadius: '4px' }}
            disabled={selectService.length === 0}
          >
            {getFormatMessage('create_export_task')}
          </Button>
        </div>
      );
    }
    return null;
  };

  return (
    <Drawer
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            borderBottom: '1px solid #E5E6EB',
            paddingBottom: 10,
          }}
        >
          <div style={{ display: 'flex' }}>
            <span>{getFormatMessage('export_environment_configuration')}</span>
          </div>
          <img src={closeIcon} className="sync-close-icon" onClick={onClose} />
        </div>
      }
      visible={props.visible}
      onClose={onClose}
      width={720}
      closable={false}
      footer={footer()}
    >
      {renderExportContent()}
    </Drawer>
  );
};
